import { useEffect } from 'react'
import { Trash2, Share2, Pencil } from 'lucide-react'

type Props = {
  onClose:  () => void
  onDelete: () => void
  onShare?: () => void
  onEdit?:  () => void
}

export function RecipeOverflowMenu({ onClose, onDelete, onShare, onEdit }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-[60] flex items-end justify-center"
      role="dialog"
      aria-modal="true"
    >
      <button
        aria-label="Close menu"
        onClick={onClose}
        className="absolute inset-0 bg-black/30"
      />
      <div className="relative w-full max-w-[420px] bg-cream rounded-t-[20px] pb-6 px-4 pt-5 animate-[recipeMenuSlideUp_200ms_ease-out]">
        <div className="h-1 w-10 rounded-full bg-[#D4C4A8] mx-auto mb-4" />

        <div className="rounded-[14px] border border-border-sand bg-paper overflow-hidden">
          {onEdit && (
            <button
              onClick={onEdit}
              className="w-full flex items-center gap-3 px-4 py-[14px] border-b border-border-hairline text-left"
            >
              <Pencil className="h-4 w-4 text-ink-muted" strokeWidth={1.6} />
              <span className="font-serif text-[15px] text-ink">Edit recipe</span>
            </button>
          )}
          {onShare && (
            <button
              onClick={onShare}
              className="w-full flex items-center gap-3 px-4 py-[14px] border-b border-border-hairline text-left"
            >
              <Share2 className="h-4 w-4 text-ink-muted" strokeWidth={1.6} />
              <span className="font-serif text-[15px] text-ink">Share recipe</span>
            </button>
          )}
          <button
            onClick={onDelete}
            className="w-full flex items-center gap-3 px-4 py-[14px] text-left"
          >
            <Trash2 className="h-4 w-4 text-critical" strokeWidth={1.6} />
            <span className="font-serif text-[15px] italic text-critical">Delete recipe</span>
          </button>
        </div>

        <button
          onClick={onClose}
          className="w-full mt-3 rounded-[14px] bg-paper border border-border-sand py-3 text-[13px] font-semibold text-ink"
        >
          Cancel
        </button>
      </div>

      <style>{`
        @keyframes recipeMenuSlideUp {
          from { transform: translateY(100%); }
          to   { transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
